const KEY = 'pixellab.deviceID'

/**
 * Get or create a persistent device identity for browser grace period.
 * Stored in sessionStorage — unique per tab, survives page refresh (F5).
 *
 * Why sessionStorage, not localStorage:
 *   localStorage is shared across tabs → two tabs get the same deviceID →
 *   relay Case C (same device, live) silently closes the old tab's WS
 *   WITHOUT session_replaced → old tab's onclose reconnects → kicks new
 *   tab → infinite ping-pong loop (C-6).
 *   sessionStorage is per-tab → two tabs get different deviceIDs → relay
 *   Case E (different device) → session_replaced → old tab logs out cleanly.
 *
 * Legacy clients without deviceID get immediate replacement on reconnect
 * (relay treats empty device_id as "no grace").
 */
export function getOrCreateDeviceId(): string {
  let id = sessionStorage.getItem(KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(KEY, id)
  }
  return id
}

export function clearDeviceId(): void {
  sessionStorage.removeItem(KEY)
}
